import { AppEnvs } from 'enums';
import getAdobeDCRConfig from './getAdobeDCRConfig';

export default (
    content,
    authorization = {},
    streamlimiter,
    nielsenTrackingData = {},
    isMobile = false,
    error = null,
    env,
    locale,
    provider = {}
) => {
    // if we get to the point of embed, autoplay will always be on, unless its mobile
    let autoplay = 'on';
    if (isMobile === true) {
        // for mobile, initialEmbed means we can't tie embed to user click, pass "off" allow thumbnail to show
        // #TODO work with player team on autoplay for mobile
        autoplay = (content.initialEmbed === true) ? 'off' : 'on';
    }

    let conviva = null;
    const { name: affiliate } = provider;
    const wasUserInitiated = !!content.userInitiated;

    if (content.type === 'video') {
        const moreOptions = {};
        if (content.playlist && content.playlist.length > 0) {
            moreOptions.playlist = content.playlist;
        } else {
            moreOptions.clipId = content.id;
        }

        if (env === AppEnvs.prod) {
            conviva = {
                customerKey: 'fc8dbfdc5da519f576628f619306a357f31bd006'
            };
        }

        return {
            affiliate,
            ...moreOptions,
            advertising: {
                siteSectionId: 'watchespn:desktop:vod'
            },
            analytics: {
                adobeDCR: getAdobeDCRConfig(nielsenTrackingData, {}, env),
                conviva,
                comscore: {
                    labels: {
                        c4: '"watchespncom"'
                    }
                }
            },
            autoplay,
            endcard: true,
            preroll: true,
            wasUserInitiated
        };
    } else if (content.type === 'event') {
        const asset = (({ sourceType, sourceId, id }) => {
            if (sourceType === 'online') {
                return {
                    watchId: id,
                    channelId: sourceId
                };
            }
            return {
                channelId: sourceId
            };
        })(content);

        const auth = {
            auth: {
                token: window.btoa(unescape(encodeURIComponent(authorization.token || ''))),
                resource: window.btoa(unescape(encodeURIComponent(authorization.resourceId || ''))),
                tokenType: authorization.tokenType || 'ADOBEPASS'
            }
        };

        if (env === AppEnvs.prod) {
            conviva = {
                customerKey: '766ee8daa5d5deaeeeab4481239072ea53f6f1cc'
            };
        }

        let api = {};
        if (content.sourceId === 'SHORTSTOPLIVE') {
            api = {
                WATCH_BASE_URL: 'http://broadband.espnqa.com/espn360/apis/v1/watch'
            };
        }

        return Object.assign({
            affiliate,
            language: locale,
            autoplay,
            advertising: {
                assetId: content.id
            },
            analytics: {
                adobeDCR: getAdobeDCRConfig(nielsenTrackingData, {}, env),
                conviva,
                comscore: {
                    labels: {
                        c4: '"watchespncom"'
                    }
                }
            },
            api,
            wasUserInitiated
        }, asset, auth, { streamlimiter }, { error });
    }
    return null;
};



// WEBPACK FOOTER //
// ./app/player/util/getPlayerOptions.js